import { useTranslations } from '@ms/yammer-i18n-react';
import TeamsStrings from '@ms/yammer-strings/dist/Teams';
import { vivaEngageLogoPath, yammerLogoPath } from '@ms/yammer-web-components/dist/images';
import { FixedGridColumn, FixedGridRow } from '@ms/yammer-web-core-ui/dist/components/FixedGrid';
import Image from '@ms/yammer-web-core-ui/dist/components/Image';
import SemanticHeading from '@ms/yammer-web-core-ui/dist/components/SemanticHeading';
import Text, { FontWeight, TextSize } from '@ms/yammer-web-core-ui/dist/components/Text';
import { useTheme } from '@ms/yammer-web-core-ui/dist/util/theme';
import { useIsVivaEngageApp } from 'hooks/useIsVivaEngageApp';
import React, { FC } from 'react';

import { getClassNames } from './AppHeaderLogo.styles';

const AppHeaderLogo: FC = () => {
  const theme = useTheme();
  const t = useTranslations(TeamsStrings);
  const { logoImage, logoText } = getClassNames(theme);
  const isVivaEngageApp = useIsVivaEngageApp();
  const logoWidth = isVivaEngageApp ? 24 : 32;
  const logoHeight = isVivaEngageApp ? 24 : 32;
  const logoWrapperWidth = isVivaEngageApp ? 32 : 44;
  const headerLogoPath = isVivaEngageApp ? vivaEngageLogoPath : yammerLogoPath;
  const headerText = isVivaEngageApp ? t.manifestVivaEngageNameShort() : t.manifestNameShort();
  const headerTextVerticalAlign = isVivaEngageApp ? 'top' : 'center';

  return (
    <FixedGridRow columnSpacing={2}>
      <FixedGridColumn className={logoImage} width={logoWrapperWidth} fixed={true}>
        <Image source={headerLogoPath} height={logoHeight} width={logoWidth} description="" />
      </FixedGridColumn>
      <FixedGridColumn verticalAlign={headerTextVerticalAlign} className={logoText}>
        <Text fontWeight={FontWeight.Bold} size={TextSize.Medium}>
          {headerText}
        </Text>
        <SemanticHeading level={1} screenreaderOnly={true}>
          {headerText}
        </SemanticHeading>
      </FixedGridColumn>
    </FixedGridRow>
  );
};

export default AppHeaderLogo;
